
import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
const initialState = {
    currentMenuKey:sessionStorage.getItem('currentMenuKey')?sessionStorage.getItem('currentMenuKey'):"6",
};

export const schoolAdminPageSlice = createSlice({
    name: 'schoolAdminPage',
    initialState,
    reducers: {
        setCurrentMenuKey: (state,action) => {
            sessionStorage.setItem('currentMenuKey',action.payload);
            state.currentMenuKey = action.payload;
        }
    },
});

export const selectCurrentMenuKey = (state) => state.schoolAdminPage.currentMenuKey;
export const {
    setCurrentMenuKey
} = schoolAdminPageSlice.actions;

export default schoolAdminPageSlice.reducer;
